<template lang="pug">
  .ballsaal
    h1(v-html='headline')
    seperator
    .body
      p(v-for='paragraph in body', v-html='paragraph')
      a.cta(:href='"mailto:" + email') Jetzt Anfragen

    .clear
</template>

<script>
  import seperator from '@/components/Seperator'
  export default {
    components: {
      seperator
    },
    data () {
      return {
        title: 'Ballsaal',
        indicator: require('@/assets/img/donauhof-ballsaal.svg'),
        image: require('@/assets/img/donauhof-ballsaal-image.jpg'),
        background: {
          rotate: 0,
          scale: {
            x: 6,
            y: 8
          },
          translate: {
            x: '-20%',
            y: '30%'
          }
        },
        headline: 'Lange in Vergessenheit geraten und der Öffentlichkeit unbekannt, ist der Ballsaal das Herzstück des Donauhofs.',
        body: [
          'Der sich in Renovierung befindende Ballsaal erinnert an den Glanz alter Zeiten ohne überheblich zu wirken. Veranstaltungen aller Art finden hier ihren Platz. Die Renovierung der 400m<sup>2</sup> wird dieses Jahr abgeschlossen. Vereinzelt können auch Veranstaltungen vor der Fertigstellung stattfinden.'
        ],
        email: 'office@donauhofwien.at'
      }
    },
    head () {
      return {
        title: this.title
      }
    }
    // created () {
    //   this.$parent.currentIndicator = this.indicator
    //   this.$parent.currentImage = this.image
    // }
  }
</script>

<style lang="scss" scoped>
  @import "~utils";
</style>



// WEBPACK FOOTER //
// Ballsaal.vue?d0ab353e